import * as React from 'react'
import { Button, Form } from 'react-bootstrap'


import ResidentialItems, { categoryItems, getVolume, ResidentialItemCategories } from './ResidentialItems'
import { copyObject, randomId } from '../../../../../utils'
import { CargoObj, CargoT } from '../../../../../types/CargoT'
import _ from 'lodash'


interface AddCubeSheetItemProps {
  addCargo(cargoItem: CargoT): void
}

export const itemSelect = (category: string): Array<JSX.Element> => {
  let items = categoryItems(category)
  let retArr = []
  for (let i = 0; i < items.length; ++i) {
    retArr.push(<option value={items[i].item}>{items[i].item}</option>)
  }
  return retArr
}

const AddCubeSheetItem: React.FunctionComponent<AddCubeSheetItemProps> = (props): JSX.Element => {
  const [category, setCategory] = React.useState('')
  const [item, setItem] = React.useState('')


  const categorySelect = (): Array<JSX.Element> => {
    return ResidentialItemCategories.map((category: string, index: number): JSX.Element => {
      return (
        <option key={index} value={category}>{category}</option>
      )
    })
  }

  return (
    <div className='d-flex flex-row' style={{ gap: 4 }}>
      <div className='d-flex '>
        <Form.Group>
          <Form.Label>Category</Form.Label>
          <Form.Control
            as='select'
            className='input-material'
            onChange={(event: any) => { setCategory(event.target.value) }}>
            <option></option>
            {categorySelect()}
          </Form.Control>
        </Form.Group>
      </div>
      {category != '' && <div className='d-flex '>
        <Form.Group>
          <Form.Label>Item</Form.Label>
          <Form.Control
            as='select'
            className='input-material'
            onChange={(event: any) => { setItem(event.target.value) }}>
            <option></option>
            {itemSelect(category)}
          </Form.Control>
        </Form.Group>
      </div>}
      <div className='d-flex align-items-center'>

        <Button
          style={{ marginTop: 15 }}
          disabled={item == '' ? true : false}
          onClick={(): void => {
            let cargoObjClone = _.cloneDeep(CargoObj)
            cargoObjClone.id = randomId()
            cargoObjClone.category = category
            cargoObjClone.item = item
            cargoObjClone.units = 1
            cargoObjClone.volume = getVolume(category, item)
            setCategory('')
            setItem('')
            props.addCargo(cargoObjClone)
          }}
          variant='info'>
          Add
        </Button>
      </div>
    </div>
  )
}

export default AddCubeSheetItem
